<div
    class="unit-switcher-overlay"
    *ngIf="visible"
    (click)="close()"
>
    <div class="unit-switcher-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
        <div class="unit-switcher-search">
            <i class="pi pi-search"></i>
            <input
                #searchInput
                type="text"
                pInputText
                [(ngModel)]="filterValue"
                (ngModelChange)="applyFilter()"
                [placeholder]="'' | language: 'UNIT_SWITCHER_SEARCH_UNITS' : languageProvider.currentLanguage"
                autocomplete="off"
            />
            <kbd class="unit-switcher-kbd">Esc</kbd>
        </div>

        <div class="unit-switcher-results" #resultsList>
            <ng-container *ngIf="groupedUnits.length; else emptyState">
                <div class="unit-group" *ngFor="let group of groupedUnits">
                    <div class="unit-group-heading">{{ group.organisationName }}</div>
                    <button
                        type="button"
                        class="unit-item"
                        tabindex="-1"
                        *ngFor="let unit of group.units"
                        [class.active]="isActiveIndex(unit)"
                        [class.current]="isSelected(unit)"
                        (click)="selectUnit(unit)"
                        (mouseenter)="setActiveUnit(unit)"
                    >
                        <div class="unit-item-main">
                            <div class="unit-item-name">{{ unit.salesLocationName }}</div>
                            <div class="unit-item-route">{{ unit.salesLocationRoute }}</div>
                        </div>
                        <span class="unit-item-id">{{ unit.salesLocationRestaurantId ?? '—' }}</span>
                    </button>
                </div>
            </ng-container>
            <ng-template #emptyState>
                <div class="unit-switcher-empty">
                    {{ '' | language: 'UNIT_SWITCHER_NO_RESULTS' : languageProvider.currentLanguage }}
                </div>
            </ng-template>
        </div>

        <div class="unit-switcher-footer">
            <div class="unit-switcher-footer-hints">
                <span><kbd>↑</kbd> <kbd>↓</kbd> {{ '' | language: 'UNIT_SWITCHER_SELECT' : languageProvider.currentLanguage }}</span>
                <span><kbd>Enter</kbd> {{ '' | language: 'UNIT_SWITCHER_OPEN' : languageProvider.currentLanguage }}</span>
                <span><kbd>Esc</kbd> {{ '' | language: 'UNIT_SWITCHER_CLOSE' : languageProvider.currentLanguage }}</span>
            </div>
            <button type="button" class="unit-switcher-show-all" (click)="navigateToUnitSelection()">
                &#8594; {{ '' | language: 'SHOW_ALL' : languageProvider.currentLanguage }}
            </button>
        </div>
    </div>
</div>
